import { Reveal, SectionHead } from "./Reveal";

const CASES = [
  {
    industry: "B2B SaaS",
    metric: "2 enterprise deals in Q1",
    body: "Reframed the entire go-to-market approach within weeks of engagement — 100%+ ROI improvement within 6 months, without increasing spend.",
    quote: "Aspen came in and within weeks had reframed our entire go-to-market approach.",
    person: "James R.",
    role: "CEO, B2B SaaS",
  },
  {
    industry: "Fintech",
    metric: "22% lower CAC in 90 days",
    body: "Audited every dollar of paid spend, rebuilt the funnel, and aligned marketing with sales around a single pipeline number.",
    quote: "We were spending on ads with nothing to show for it. She audited everything and rebuilt our funnel.",
    person: "Sofia M.",
    role: "VP Marketing, Fintech",
  },
  {
    industry: "Consumer Brands",
    metric: "Hundreds of sales per activation day",
    body: "Strategic roadshows and experiential programs for Yerbae, CELSIUS, and Premier Protein — converting shoppers into loyal customers.",
    quote: "Having a CMO-level brain without the CMO price tag changed how we operate. Aspen is the real deal.",
    person: "Daniel K.",
    role: "Founder, Consumer Brand",
  },
];

const CaseStudies = () => (
  <section id="work" data-testid="case-studies-section" className="px-6 md:px-12 py-24 md:py-36 border-t border-line">
    <div className="mx-auto max-w-[100rem]">
      <SectionHead
        index="05"
        label="Case Studies"
        title={<>Proof, <em className="text-taupe">not promises.</em></>}
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 border-t border-l border-line">
        {CASES.map((c, i) => (
          <Reveal key={c.industry} delay={i * 0.08} className="border-b border-r border-line">
            <article data-testid={`case-study-${c.industry.toLowerCase().replace(/\s+/g, "-")}`} className="flex h-full flex-col p-8 md:p-10">
              <p className="text-xs uppercase tracking-[0.25em] text-taupe">{c.industry}</p>
              <h3 className="mt-8 font-serif text-3xl md:text-4xl font-light tracking-tight leading-tight">
                {c.metric}
              </h3>
              <p className="mt-4 text-sm font-light text-ash leading-relaxed">{c.body}</p>
              <blockquote className="mt-auto pt-10">
                <p className="font-serif italic text-lg leading-relaxed text-ink/80">"{c.quote}"</p>
                <footer className="mt-4 text-xs uppercase tracking-[0.2em] text-ash">
                  {c.person} — {c.role}
                </footer>
              </blockquote>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div data-testid="case-studies-capstone" className="mt-20 md:mt-28 max-w-3xl">
          <p className="overline-label">From startups to national brands</p>
          <p className="mt-6 text-base md:text-lg font-light text-ash leading-relaxed">
            Makkar Growth Partners brings together executive-level strategy and
            hands-on execution across nonprofit, entertainment, consumer packaged
            goods, wellness, digital media, and emerging brands. Whether the
            challenge is building a brand from zero, introducing a product to new
            consumers, strengthening digital engagement, developing partnerships,
            or creating a scalable marketing infrastructure, the objective remains
            the same:
          </p>
          <p className="mt-8 font-serif text-3xl md:text-4xl font-light tracking-tight leading-snug">
            Turn attention into <em className="text-taupe">engagement.</em><br />
            Turn engagement into <em className="text-taupe">action.</em><br />
            Turn action into <em className="text-taupe">sustainable growth.</em>
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CaseStudies;
